
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { useParams } from 'react-router-dom';
import apiCalls from 'src/api/apiCalls';
import List from 'src/components/grid.component';
import AddressCell from 'src/utils/addressCell';

const ExchangeDetails=()=>{
let { custId } = useParams();
const exchnageUrl = process.env.REACT_APP_GRID_API + `ExchangeWallet/Admin/Exchange/${custId}/All`;
    const gridRef = React.createRef();
    useEffect(()=>{
        gridRef.current?.refreshGrid();
    },[])

    const [lookupData, setLookupData] = useState({
        walletCode: [],
        errorMsg: null,
        copied: '',
    });
    useEffect(()=>{
        walletcodeLu()
    },[])

    const walletcodeLu = async () => {
        try {
            const response = await apiCalls.exchangewalletLu();
            if (response.ok) {
                setLookupData(prevState => ({
                    ...prevState,
                    walletCode: response.data,
                }))
            }
            else {
                setLookupData(prevState => ({
                    ...prevState,
                    errorMsg:apiCalls.isErrorDispaly(response)
                }))
            }
        }
        catch (error) {
            setLookupData(prevState => ({
                ...prevState,
                errorMsg: walletCodeErrMsg,
            }));
        }
    }


    const renderCustomCell = (prop, column) => {
        const customcells = {
            "customerName": (exchange) => (<td><div><button className='gridLink c-pointer batch-filename px-0' onClick={() => navigate(`/customer/${exchange?.dataItem?.customerId}/Exchange`)}>{(exchange?.dataItem?.customerName)}</button></div></td>),
            "balance":(exchange)=>(<td><div><NumberFormat value={exchange?.dataItem?.balance || 0} displayType="text" thousandSeparator={true} /></div></td>),
            "address":((exchange) =>
                <AddressCell
                  id={exchange?.dataItem?.id}
                  address={exchange?.dataItem?.address}
                  copied={lookupData?.copied}
                  handleCopy={handleCopy}
                />)
        }
        if (customcells[column.field])
            return customcells[column.field](prop);
    }

    const handleCopy = (id) => {
        setLookupData((prev) => ({
            ...prev,
            copied: id
        }));
        setTimeout(() => {
            setLookupData((prev) => ({
                ...prev,
                copied: ''
            }));
        }, 300)
    }
    return(
        <div>
        <List
         showExcelExport={true}
         url={exchnageUrl}
         screenName={"Customers_Exchange"}
         renderCustomCell={renderCustomCell}
         ref={gridRef}
         pSize={10}
         hasFooter={true}
        className="custom-grid card-historylist"
     />
    </div>
    )
}
export default ExchangeDetails